export const DEFAULT_PHONE = {
  countryCode: "852",
  areaCode: "",
  number: "",
};

const digitsOnly = (value) => String(value ?? "").replace(/\D/g, "");

export const normalizePhone = (value) => {
  if (value === null || value === undefined || value === "") {
    return { ...DEFAULT_PHONE };
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return { ...DEFAULT_PHONE };

    const digits = digitsOnly(trimmed);
    if (trimmed.startsWith("+") && digits.length > 3) {
      const countryCode = digits.slice(0, 3);
      const remainder = digits.slice(3);
      return {
        countryCode,
        areaCode: "",
        number: remainder,
      };
    }

    return {
      countryCode: DEFAULT_PHONE.countryCode,
      areaCode: "",
      number: trimmed,
    };
  }

  if (typeof value === "object") {
    return {
      countryCode: value.countryCode?.trim() || DEFAULT_PHONE.countryCode,
      areaCode: value.areaCode?.trim() ?? DEFAULT_PHONE.areaCode,
      number: value.number?.trim() ?? DEFAULT_PHONE.number,
    };
  }

  return { ...DEFAULT_PHONE };
};

export const isPhoneObject = (value) =>
  value !== null &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  "countryCode" in value &&
  "number" in value;

export const formatPhoneDisplay = (phone) => {
  const normalized = normalizePhone(phone);
  const { countryCode, areaCode, number } = normalized;

  if (!number) return "";

  const parts = [`+${countryCode}`];
  if (areaCode) parts.push(areaCode);
  parts.push(number);
  return parts.join(" ");
};

export const formatDisplayValue = (value) => {
  if (isPhoneObject(value)) return formatPhoneDisplay(value);
  return value;
};

export const phoneToE164 = (phone) => {
  const normalized = normalizePhone(phone);
  const digits = [
    normalized.countryCode,
    normalized.areaCode,
    normalized.number,
  ]
    .map(digitsOnly)
    .join("");

  return digits || "";
};

export const phoneExportParts = (phone) => {
  const normalized = normalizePhone(phone);
  return {
    countryCode: normalized.countryCode,
    areaCode: normalized.areaCode,
    number: normalized.number,
  };
};

export const isPhoneComplete = (phone) =>
  Boolean(normalizePhone(phone).number?.trim());

export const ensurePhoneField = (form, fieldName) => {
  const current = form.values?.[fieldName];
  if (typeof current === "string" || current === null || current === undefined) {
    form.setFieldValue(fieldName, normalizePhone(current));
  }
};
